import { render } from "./PhotoLightbox.vue?vue&type=template&id=8400213e&scoped=true"
import script from "./PhotoLightbox.vue?vue&type=script&lang=js"
export * from "./PhotoLightbox.vue?vue&type=script&lang=js"

import "./PhotoLightbox.vue?vue&type=style&index=0&id=8400213e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8400213e"]])

export default __exports__